module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedit"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("To the staff of Queen’s Hospital Romford and all NHS workers")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("This book shows the example of how Britain’s railway workers went way beyond their normal duties to help the country through the crisis of the Second World War. The workers of the NHS have done the same in today’s different kind of crisis and have led the way to enable the people of the UK to come through it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca35c138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Dedication.vue
// module id = 69
// module chunks = 0